import { USER_INFO } from "./ActionConstants";

export const reducer = (state, action) => {
    switch (action.type) {
        case USER_INFO:
            return { ...state, user: action.payload };
        default:
            return state;
    }
};